import { UserMin } from '@rdTypes/apiContract';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type RecipientFilterState = {
  user: UserMin | null;
  qrCode: string | null;
};

const initialState: RecipientFilterState = {
  user: null,
  qrCode: null,
};

const recipientFilterSlice = createSlice({
  name: 'recipientFilter',
  initialState,
  reducers: {
    setRecipientFilter: (state, { payload }: PayloadAction<{ user: UserMin; qrCode: string }>) => {
      state.user = payload.user;
      state.qrCode = payload.qrCode;
    },
    clearRecipientFilter: (state) => {
      state.user = null;
      state.qrCode = null;
    },
  },
});

export const { setRecipientFilter, clearRecipientFilter } = recipientFilterSlice.actions;

export default recipientFilterSlice.reducer;
